import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import moment from "moment";
import { TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { getLocalStorage } from "../layout/cookies/CookieFunctions";

const useStyles = makeStyles((theme) => ({
  marginNormal: {
    marginTop: theme?.spacing ? theme.spacing(2) : null,
    marginBottom: theme?.spacing ? theme.spacing(1) : null,
  },
}));

const TimePickerComponent = (props) => {
  const {
    name,
    label,
    value,
    helperText,
    error,
    setFieldValue,
    variant,
    required,

    setFieldTouched,
    touched,

    disabled,
  } = props;
  const classes = useStyles();

  const locale = getLocalStorage("locale") || "en-us";

  if (moment.locale() !== locale) {
    moment.locale(locale);
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
      <TimePicker
        className={classes.marginNormal}
        fullWidth
        inputVariant={variant || "outlined"}
        label={label}
        name={name}
        disabled={disabled}
        value={moment(value)}
        onChange={(newMoment) => {
          if (newMoment && newMoment !== null) {
            setFieldValue(name, newMoment.format("HH:mm"), true);
          } else {
            setFieldValue(name, null, true);
          }
          if (setFieldTouched && touched) setFieldTouched(name);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            margin="normal"
            required={required || false}
            error={error}
            helperText={helperText}
            disabled={disabled}
          />
        )}
        sx={{ width: "100%" }}
      />
    </LocalizationProvider>
  );
};

export default TimePickerComponent;
